import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Icon from '../Icon'
import FormikForm from '../../form/FormikForm'

export const Container = styled.div`
  width: max-content;
  display: grid;
  justify-items: center;
  @media ${mq(sizes.desktop)} {
    position: relative;
    justify-items: start;
  }
`

export const Trigger = styled.button`
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${pxToRem(2)};
  height: 100%;
  padding-inline: ${pxToRem(20)};
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black};
  background: unset;
  transition: opacity 0.3s ease-in-out;
  &[aria-expanded='true'] {
    opacity: 0;
    visibility: hidden;
  }
  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0 0 0 0;
    background: ${({ theme }) => theme.colors.white};
    transition: transform 0.3s ease-in-out;
    transform: translateY(-100%);
  }
  &:hover::before,
  &:focus::before,
  &[aria-expanded='true']::before {
    transform: translateY(-0%);
  }
  &::after {
    content: '';
    position: absolute;
    height: 1px;
    inset-block-start: 100%;
    inset-inline: 0;
    background: transparent;
  }
  &[aria-expanded='true']::after {
    background: ${({ theme }) => theme.colors.greyAA};
  }
  @media ${mq(sizes.desktop)} {
    font-size: ${pxToRem(16)};
    padding-inline: ${pxToRem(32)};
    transition:
      opacity 0.3s ease-in-out 0s,
      visibility 0s 0s;
    &[aria-expanded='true'] {
      transition:
        opacity 0.3s ease-in-out 0.3s,
        visibility 0s 0.6s;
    }
  }
`
export const _Icon = styled(Icon)`
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
export const _FormikForm = styled(FormikForm)`
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
  display: grid;
  grid-template-columns: [field] 1fr [reset] auto [submit] auto;
  align-items: center;
  gap: ${pxToRem(16)};
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  // specific to mobile
  position: absolute;
  inset-block: 0;
  inset-inline-start: 50%;
  z-index: ${({ theme }) => theme.zIndexes.modal};
  transform: translateX(-50%);
  width: 100vw;
  transition: width 0.3s ease-in-out;
  // / specific to mobile
  &[hidden] {
    display: grid;
    visibility: hidden;
    pointer-events: none;
    width: 0;
  }
  @media ${mq(sizes.desktop)} {
    inset-inline-start: 0;
    transform: unset;
    width: ${pxToRem(320)};
    transition:
      width 0.3s ease-in-out,
      visibility 0s 0s;
    &[hidden] {
      transition:
        width 0.3s ease-in-out,
        visibility 0s 0.3s;
    }
  }
`
export const Placeholder = styled.label`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 3;
  grid-column: field / span 1;
  grid-row: 1;
  margin-inline-start: ${pxToRem(16)};
  color: rgba(0, 0, 0, 0.5);
  transition:
    transform 0.3s ease-in-out,
    font-size 0.3s ease-in-out;
  input:focus ~ &,
  input:not(:placeholder-shown) ~ & {
    transform: translateY(-125%);
    font-size: 0.75em;
  }
`
export const Input = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'error',
})`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 1;
  grid-column: field / span 1;
  grid-row: 1;
  align-self: stretch;
  margin-inline-start: ${pxToRem(16)};
  margin-block: 1px;
  padding: unset;
  border: none;
  background-color: transparent;
  &:focus,
  &:focus-visible {
    outline: unset;
  }
  &::placeholder {
    color: transparent;
  }
  &::placeholder {
    color: transparent;
  }
  &::-ms-clear {
    display: none;
  }
  &::-webkit-search-cancel-button {
    display: none;
  }
`
export const Reset = styled.button`
  position: relative;
  z-index: 2;
  grid-column: reset / span 1;
  grid-row: 1;
  display: flex;
  background: unset;
  transition:
    opacity 0.15s ease-in-out,
    visibility 0s 0s;
  input:placeholder-shown ~ & {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition:
      opacity 0.15s ease-in-out,
      visibility 0s 0.15s;
  }
`
export const ResetIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
`
export const Submit = styled.button`
  position: relative;
  z-index: 2;
  grid-column: submit / span 1;
  grid-row: 1;
  display: flex;
  margin-inline-end: ${pxToRem(16)};
  background: unset;
`
export const SubmitIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
